(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiuquty-product-aplus"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kiuquty-aplus-carousel')) {
    class KiuqutyAplusCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = [...this.querySelectorAll('.kiuquty-aplus__slide')];
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.dots = [...this.querySelectorAll('[data-carousel-dot]')];
        this.counter = this.querySelector('[data-carousel-current]');
        this.currentIndex = 0;
        this.scrollTimer = null;
        this.abortController = new AbortController();
        const listenerOptions = { signal: this.abortController.signal };

        this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1), listenerOptions);
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1), listenerOptions);
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slideIndex)), listenerOptions);
        });
        this.track?.addEventListener('scroll', () => this.handleScroll(), listenerOptions);
        this.track?.addEventListener('scrollend', () => this.settleAtNearest(), listenerOptions);
        this.track?.addEventListener('keydown', (event) => this.handleKeydown(event), listenerOptions);
        window.addEventListener('resize', () => this.goTo(this.currentIndex), listenerOptions);

        this.updateControls();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        window.clearTimeout(this.scrollTimer);
      }

      goTo(index) {
        if (!this.track || this.slides.length === 0) return;
        const boundedIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        this.currentIndex = boundedIndex;
        this.updateControls();
        this.track.scrollTo({
          left: boundedIndex * this.track.clientWidth,
          behavior: 'auto',
        });
      }

      handleScroll() {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => this.settleAtNearest(), 120);
      }

      settleAtNearest() {
        if (!this.track?.clientWidth) return;
        const nearestIndex = Math.round(this.track.scrollLeft / this.track.clientWidth);
        const boundedIndex = Math.max(0, Math.min(nearestIndex, this.slides.length - 1));
        this.currentIndex = boundedIndex;
        this.track.scrollTo({ left: boundedIndex * this.track.clientWidth, behavior: 'auto' });
        this.updateControls();
      }

      handleKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.goTo(this.currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }

      updateControls() {
        if (this.previousButton) this.previousButton.disabled = this.currentIndex === 0;
        if (this.nextButton) this.nextButton.disabled = this.currentIndex === this.slides.length - 1;
        this.dots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === this.currentIndex ? 'true' : 'false');
        });
        if (this.counter) this.counter.textContent = String(this.currentIndex + 1);
      }
    }

    customElements.define('kiuquty-aplus-carousel', KiuqutyAplusCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
